"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importDefault(require("react"));
const textarea_1 = __importDefault(require("@kyruus/textarea"));
const prop_types_1 = __importDefault(require("prop-types"));
const read_only_1 = __importDefault(require("../../read-only"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const styles_1 = require("../../../styles");
const TextareaInput = ({ path }) => {
    const [state, actions] = (0, use_form_1.default)(path, {
        eventProcessor: (event) => event.target.value
    });
    const { AddOn, config } = state;
    // isResizable boolean prop allows vertical resizing (see @kyruus/textarea or https://kyruus.jira.com/browse/KENG-13712)
    if (!config.isVisible)
        return null;
    if (config.isReadOnly) {
        return react_1.default.createElement(read_only_1.default, { msg: state.value });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.FieldFocusWrapper, { hasError: !!state.errors.length },
            react_1.default.createElement(textarea_1.default, { errors: state.errors, required: config.isRequired, onChange: actions.onChange, onBlur: actions.onBlur, value: state.value, placeholder: config.placeholder, disabled: config.isReadOnly, id: path, name: path, label: config.label, hideLabel: true, "data-testid": path, maxLength: config.maxLength, displayCharacterCount: config.displayCharacterCount, characterCountReachedMessage: config.characterCountReachedMessage, isResizable: config.isResizable, resize: config.resize, rows: config.rows })),
        react_1.default.createElement(AddOn, null)));
};
TextareaInput.propTypes = {
    path: prop_types_1.default.string.isRequired
};
exports.default = TextareaInput;
exports.defaultConfig = {};
//# sourceMappingURL=index.js.map